<!-- @format -->

<div class="container sis-pt-md">
  <sis-page-title [title]="titleKey | translate" />
  <p>{{ descriptionKey | translate }}</p>
</div>
